import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { UpLoadingApiService } from 'features/unloading-log/api/unloading-api.services';
import { queryClient } from 'providers';

import { UpLoadingQueryKeys } from './query-keys';
// ../api/unloading-api.services
const { ApporveReject } = UpLoadingApiService();

export const useApproveRejectUnloading = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload:any) => {
      return ApporveReject(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data:any) => {
        queryClient.invalidateQueries({
          queryKey: UpLoadingQueryKeys.lists(),
        });
        if(data?.res==0){
          message.error(data?.customMessage)
        }else{
          message.success(data?.customMessage)
        }
      }
    },
  );
};










